<template>
  <div class="page-bg login">
    <v-container fill-height justify-center>
      <div class="login-block">
        <div class="Client-logo">
          <img :src="logo" class="Client-logo-img" />
        </div>
        <v-form class="login-frm">
          <v-row>
            <v-col cols="12" sm="12" class="pad-zero">
              <span class="new-signup-user">New User Sign Up</span>
            </v-col>
            <v-col cols="12" sm="12" class="pad-zero">
              <v-text-field
                v-model="name"
                label="Name"
                hide-details
                dense
                outlined
                class="required"
              ></v-text-field>
              <InputError :data="error.name" />
            </v-col>
            <v-col cols="12" sm="12" class="pad-zero">
              <v-text-field
                v-model="email"
                label="Email ID"
                hide-details
                dense
                outlined
                class="required"
              ></v-text-field>
              <InputError :data="error.email" />
            </v-col>
            <v-col cols="12" sm="12" class="pad-zero user-type">
              <v-select
                v-model="selectedRole"
                @change="onRoleSelect"
                :items="items"
                label="User Type"
                hide-details
                dense
                outlined
                class="required"
              ></v-select>
              <InputError :data="error.role" />
            </v-col>
            <v-col cols="12" sm="12" class="pad-zero">
              <div class="signup-primary sign-up-terms top-0">
                <div class="user-new-signup" v-if="(isCoordinator || isDeo || !selectedRole)">
                  <div class="user-terms-block" v-if="showPrivacyAndTerms">
                        <div class="user-terms-check">
                            <v-checkbox input-value="" value v-model="ischecked"></v-checkbox>
                        </div>
                        <div class="user-terms-text-outer">
                            <div class="user-terms-text">
                            I accept the <a @click="termandcondition">Terms of Service</a> 
                            and <a @click="privacyPolicy">Privacy Policy</a>
                            </div>
                        </div>
                        <InputError :data="error.ischecked" />
                  </div>
				      </div>
                <div class="sign-up-btn">
                  <v-btn
                    @click="onSubmit"
                    class="right-btn cust-btn"
                    color="primary"
                    >{{
                      isCoordinator || isDeo || !selectedRole
                        ? "Sign Up"
                        : "Next"
                    }}</v-btn
                  >
                </div>
              </div>
            </v-col>
          </v-row>
        </v-form>
        <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
          <img src="@/assets/img/logo-footer.png" class="master-logo" />
        </div>
      </div>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import constants from "@/utils/constants.js";

export default {
  name: "signup",
  data() {
    return {
      items: [],
      // isCoordinator: false,
      isDeo: false,
      email: "",
      name: "",
      selectedRole: "",
	  ischecked:false,
      error: {
        email: {
          type: null,
          message: null,
        },
        name: {
          type: null,
          message: null,
        },
        role: {
          type: null,
          message: null,
        },
		ischecked: {
          type: null,
          message: "Please accept Terms & Conditions and Privacy Policy",
        },
      },
      logo: this.getInstituteLogo(),
	  showPrivacyAndTerms:true
    };
  },
  computed: {
    ...mapState("userStore", ["signUpData", "isDefaultInstitute",'myInstitute']),
  },
  methods: {
    ...mapActions({
      getExternalRoles: "userStore/getExternalRoles",
      signUp: "userStore/signUp",
      setSignUpData: "userStore/setSignUpData",
      validateEmail: "userStore/validateEmail",
    }),
    onRoleSelect(e) {
      if (
        e
      ) {
        
        this.isCoordinator = e.role_code === this.roles.CO_ROLE_CODE;
        this.isStudent = e.role_code === this.roles.ST_ROLE_CODE;
        this.isParent = e.role_code === this.roles.PA_ROLE_CODE;
        this.isTeacher = e.role_code === this.roles.TE_ROLE_CODE;
        this.isDeo = e.role_code === this.roles.EDEO_ROLE_CODE;
        this.error.role.type = null;
      }
    },
    onSubmit() {
      if (this.validate()) {
        this.$root.showLoader = true;
        if (this.isDeo) {
          this.signUp({
            name: this.name.trim(),
            email: this.email.trim(),
            role_id: this.selectedRole.id,
          })
            .then((response) => {
              this.$root.showLoader = false;
              this.$toasted.success(`Success\n${response.message}`, {
                icon: "check_circle", className:'new-class'
              });
              this.$router.push({ name: "login" }).catch(() => {});
            })
            .catch((err) => {
              this.$root.showLoader = false;
            });
        } else {
			let reqData = {
					email:this.email,
			}
			this.validateEmail(reqData).then(response=>{
				if(response && response.length){
					this.$root.showLoader = false;

					this.error.email.type = "error";
							this.error.email.message =
							"Email ID is already registered.";
							isValid = false;
				}
				else{
					this.setSignUpData({
						name: this.name.trim(),
						email: this.email,
						role_id: this.selectedRole.id,
						selectedRoleForPreSelect: this.selectedRole,
					});
					this.$root.showLoader = false;
					if (this.isStudent) {
						this.$router.push({ name: "student-signup-step2" });
					} else if (this.isCoordinator) {
						this.$router.push({ name: "coordinator-signup-step2" });
					} else if (this.isParent) {
						this.$router.push({ name: "parent-signup-step2" });
					} else if (this.isTeacher) {
						this.$router.push({ name: "teacher-signup-step2" });
					}
				}
			}).catch(err=>{
				console.log(err)
			})
         
        }
      }
    },
    validate() {
      let isValid = true;
      this.error.name.type = null;
      this.error.email.type = null;
      this.error.role.type = null;
      this.error.ischecked.type = null;
      this.email = this.removeWhiteSpacesFromEmail(this.email);
      if (!this.name || this.name.trim().length < 1) {
        this.error.name.type = "error";
        this.error.name.message = "Please enter name";
        isValid = false;
      } else if(this.name && this.name.trim().length > 70){
        this.error.name.type = "error";
        this.error.name.message = "Name should not contain more than 70 characters";
        isValid = false;
      }
      if (!this.email.trim() || this.email.trim().length < 1) {
        this.error.email.type = "error";
        this.error.email.message = "Please enter email ID.";
        isValid = false;
      } else if (!this.isValidEmail(this.email.trim())) {
        this.error.email.type = "error";
        this.error.email.message =
          "Please enter a valid email ID.";
        isValid = false;
      }
      if (!this.selectedRole) {
        this.error.role.type = "error";
        this.error.role.message = "Select role";
        isValid = false;
      }
	  if ((this.isCoordinator || this.isDeo || !this.selectedRole) && this.showPrivacyAndTerms) {
		  if (!this.ischecked) {
			  this.error.ischecked.type = "error";
        isValid = false;
		  }
	  }
      return isValid;
    },
	termandcondition(){
		let routeData = this.$router.resolve({name: 'terms-and-conditions'});
		window.open(routeData.href, '_blank');
	},
	privacyPolicy(){
		let routeData = this.$router.resolve({name: 'privacy-policy'});
		window.open(routeData.href, '_blank');
	},
  },
  mounted() {
	  const instiute = JSON.parse(localStorage.getItem('myInstitute'));
		this.showPrivacyAndTerms = !constants.CUSTOM_DOMAIN_ID.includes(instiute.id)

	//   this.showPrivacyAndTerms = !constants.CUSTOM_DOMAIN_ID.includes(instiute.id)
    if (this.signUpData) {
      this.email = this.signUpData.email;
      this.name = this.signUpData.name;
      this.selectedRole = this.signUpData.selectedRoleForPreSelect;

      if (this.signUpData.selectedRoleForPreSelect) {
        let e = this.signUpData.selectedRoleForPreSelect;
        if (e) {          
          this.isCoordinator = e.role_code === this.roles.CO_ROLE_CODE;
          this.isStudent = e.role_code === this.roles.ST_ROLE_CODE;
          this.isParent = e.role_code === this.roles.PA_ROLE_CODE;
          this.isTeacher = e.role_code === this.roles.TE_ROLE_CODE;
          this.isDeo = e.role_code === this.roles.EDEO_ROLE_CODE;
        }
      }
    }

    this.getExternalRoles({})
      .then((response) => {
        this.loading = false;
        this.items = response
          .filter((r) => r.role_code !== this.roles.ID_ROLE_CODE)
          .map((x) => {
            let role = {};
            role.text = x.role_name.replace('s','');
            role.value = x;
			if (x.id===this.roleIds.ST) {
				role.sortBy=1
			}else if(x.id === this.roleIds.PA){
				role.sortBy=2

			}else if(x.id ===  this.roleIds.TR){
				role.sortBy=3

			}else if(x.id === this.roleIds.CO){
				role.sortBy=4

			}else if(x.id === this.roleIds.ED){
				role.sortBy=5

			}
            return role;
          });
		  this.items = _.sortBy( this.items, 'sortBy' );

      })
      .catch((err) => {
        this.loading = false;
      });
  },
  watch:{
	  ischecked(){
			this.error.ischecked.type = null;
		}
  }
};
</script>
